import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import React, { FC } from "react";
import DialogContent from "@mui/material/DialogContent";
import Skeleton from "@mui/material/Skeleton";
import DialogActions from "@mui/material/DialogActions";

const SkeletonHeaderRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
const SkeletonBodyRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
export const TableLoadingSkeleton: FC = () => (
  <>
    <DialogContent>
      <SkeletonHeaderRow>
        <Skeleton height={20} width={180} />
        <Skeleton height={20} sx={{ flex: 1 }} />
        <Skeleton height={20} sx={{ flex: 1 }} />
        <Skeleton height={20} width={180} />
      </SkeletonHeaderRow>
      {Array.from({ length: 4 }).map((_, i) => (
        <SkeletonBodyRow key={i}>
          <Skeleton height={24} width={180} />
          <Skeleton height={24} sx={{ flex: 1 }} />
          <Skeleton height={24} sx={{ flex: 1 }} />
          <Skeleton height={24} width={180} />
        </SkeletonBodyRow>
      ))}
    </DialogContent>
    <DialogActions>
      <Skeleton height={36} sx={{ borderRadius: 1 }} width={80} />
      <Skeleton height={36} sx={{ borderRadius: 1 }} width={120} />
    </DialogActions>
  </>
);
